import React from "react";
import * as ReactDOM from "react-dom";

import { Dialog } from "./Dialog";

import "./Modal.scss";

import Button from "components/Button";

const ConfirmDialog = (props: any) => {
  const {
    children,
    visible,
    close,
    onOk,
    afterClose,
    centered,
    width,
    ...restProps
  } = props;
  return (
    <Dialog
      onCancel={() => close({ triggerCancel: true })}
      visible={visible}
      width={width}
      title=""
      className="confirmModal"
      footer={
        <div className="buttonFooter">
          <Button onClick={onOk} shape="round">
            oK
          </Button>
        </div>
      }
      afterClose={afterClose}
      centered={centered}
      {...restProps}
    >
      {children}
    </Dialog>
  );
};

export default function confirm(config: any) {
  const div = document.createElement("div");
  document.body.appendChild(div);
  // let div = getProtalElement('modal-root')

  let currentConfig = { ...config, close, visible: true } as any;

  function close(...args: any[]) {
    currentConfig = {
      ...currentConfig,
      visible: false,
      // afterClose: destroy.bind(this, ...args),
    };
    render(currentConfig);
  }

  const destroy = (...args: any[]) => {
    setTimeout(() => {
      const unmountResult = ReactDOM.unmountComponentAtNode(div);

      if (unmountResult && div.parentNode) {
        div.parentNode.removeChild(div);
      }
      const triggerCancel = args.some((param) => param && param.triggerCancel);
      if (config.onClose && triggerCancel) {
        config.onClose(...args);
      }
    }, 50);
  };

  function render({ content, title, okText, cancelText, ...props }: any) {
    // console.log(title, props, content)
    ReactDOM.render(
      <ConfirmDialog
        {...props}
        okText={okText}
        cancelText={cancelText}
        afterClose={destroy}
      >
        {title && <h3 className="confirmTitle">{title}</h3>}
        {content && content}
      </ConfirmDialog>,
      div
    );
  }

  render(currentConfig);
}
